import dynamic from 'next/dynamic'
import React from 'react'

import { Box } from '@material-ui/core'

import AdsSlot from '~/components/shared/AdSlot'
import Flexbox from '~/components/shared/Flexbox'
import Desktop from '~/containers/Desktop'
import Mobile from '~/containers/Mobile'
import { ReCaptchaProvider } from '~/containers/ReCaptchaProvider'
import BlogArticleCardInfo from '~/views/Blog/BlogArticleCardInfo'
import BlogSubscribe from '~/views/Blog/BlogSubscribe'

import { BlogArticle } from '~/models/Blog'

const StickyContainer = dynamic(() =>
  import('~/components/shared/StickyContainer')
)

const BlogSubscribeWithAd = () => {
  return (
    <>
      <ReCaptchaProvider>
        <BlogSubscribe />
      </ReCaptchaProvider>

      <Box display="flex" justifyContent="center" flexWrap="wrap" mt={2}>
        <AdsSlot
          slotId="gam_halfpagemrec_posR1"
          sizes={[[300, 250]]}
          sizeMapping={[
            {
              viewport: [895, 0],
              sizes: [
                [300, 600],
                [300, 250]
              ]
            },
            { viewport: [0, 0], sizes: [] }
          ]}
          targetingArguments={{ pos: 'R1' }}
        />
      </Box>
    </>
  )
}

const BlogCards = ({ data }: { data: BlogArticle }) => {
  return (
    <>
      <Desktop>
        <Flexbox
          maxWidth="300px"
          flexDirection="column"
          position="relative"
          style={{ height: '100%' }}
        >
          <Box mb={4}>
            <BlogArticleCardInfo
              tags={data.keywords}
              date={data.last_updated}
              author={data.author}
              photographer={data.photographer}
              externalLinks={data.external_links}
            />
          </Box>
          <StickyContainer>
            <BlogSubscribeWithAd />
          </StickyContainer>
        </Flexbox>
      </Desktop>
      <Mobile>
        <>
          <Box mb={4}>
            <BlogArticleCardInfo
              tags={data.keywords}
              date={data.last_updated}
              author={data.author}
              photographer={data.photographer}
              externalLinks={data.external_links}
            />
          </Box>
          <BlogSubscribeWithAd />
        </>
      </Mobile>
    </>
  )
}

export default BlogCards
